/* @flow */
/* eslint-env es6,browser */
import _timedScheduler from './timedscheduler';
import _RAFScheduler from './rafscheduler';
import _immediateScheduler from './immediatescheduler';
import { logDebug } from './logger';
import { isValid } from './coreutils';

export const DEFAULT_SCHEDULER = 'immediate';
const FALLBACK_SCHEDULER = 'timed';

const ALL_SCHEDULERS = {
  timed: _timedScheduler,
  raf: _RAFScheduler,
  immediate: _immediateScheduler
};

export function getSchedulerObj(
  name: string = DEFAULT_SCHEDULER,
  currentScheduler: ?Scheduler = null
  // eslint-disable-next-line flowtype/no-types-missing-file-annotation, no-undef
): Scheduler {
  let n = name || DEFAULT_SCHEDULER;
  if (currentScheduler && currentScheduler.getName() === n) {
    return currentScheduler;
  }

  // create one based on name
  let _builder = ALL_SCHEDULERS[n];
  // if we don't find, use the timed one
  if (!isValid(_builder) || !_builder.isSupported()) {
    n = FALLBACK_SCHEDULER;
    _builder = ALL_SCHEDULERS[n];
  }

  const o: Scheduler = new _builder(n);
  // $FlowFixMe
  logDebug(`Using Scheduler ${o.getName()}`);
  // $FlowFixMe
  return o;
}
